import type Immutable from 'immutable'
import type { Dispatch } from 'redux'

import { basketDateChange, basketSlotChange } from 'actions/basket'
import { redirect } from 'actions/redirect'
import { availablePortions } from 'config/portionSizes'
import { resolveSlotIdForDay } from 'routes/Menu/selectors/resolveSlotIdForDay'

import type { GetState } from './types'

export const setSlotFromIds =
  (slotId?: string | null, dayId?: string | null) =>
  (dispatch: Dispatch<any>, getState: GetState) => {
    if (!dayId) {
      return
    }

    const state = getState()
    const { boxSummaryDeliveryDays } = state

    const day = boxSummaryDeliveryDays.find(
      (deliveryDay: Immutable.Map<string, any>) => deliveryDay.get('coreDayId') === dayId,
    )

    if (!day) {
      dispatch(redirect('/menu'))

      return
    }

    // Land on a bookable slot, defaulting when no (or a stale) slot id is given.
    // Leaving the slot empty makes handleExpiredBasketDate treat the chosen slot
    // as unavailable and reset the date to the landing day, silently dropping the
    // deeplinked day. fallbackToDefault keeps a stale slot id on the requested day
    // rather than bouncing (the standard path stays on the menu).
    const resolvedSlotId = resolveSlotIdForDay(state, day, {
      coreSlotId: slotId,
      fallbackToDefault: true,
    })

    if (!resolvedSlotId) {
      // No bookable slot on this day — don't honour the deeplinked date; let the
      // standard landing-day logic pick a usable day instead.
      return
    }

    dispatch(basketDateChange(day.get('date')))
    dispatch(basketSlotChange(resolvedSlotId))
  }

export const parseNumPortions = (numPortions?: string | null) => {
  const parsedNumPortions = Number(numPortions)

  const isValidNumPortions =
    !Number.isNaN(parsedNumPortions) && availablePortions.includes(parsedNumPortions)

  return isValidNumPortions ? parsedNumPortions : undefined
}
